// react-router-dom components

// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 React components
import MDBox from '../../../components/MDComponents/MDBox'
import MDTypography from '../../../components/MDComponents/MDTypography'
import MDInput from '../../../components/MDComponents/MDInput'

// Authentication layout components
import CoverLayout from '../../../layouts/authentication/components/CoverLayout'

import useResetPassword from './useResetPassword'
import Button from '../../../components/Button'

const PasswordReset = () => {
  const { handleChange, handleSubmit, registering, inputs, errors, loading } =
    useResetPassword()
  return (
    <CoverLayout>
      <Card className="!bg-secondary-background">
        <div className="bg-btn-primary rounded-lg mx-2 p-5 mt-[-1.5rem] text-center">
          <div className="!text-over-primary font-bold text-xl p-2">
            {registering
              ? 'Alege o parolă pentru contul tău'
              : 'Alege o nouă parolă pentru contul tău'}
          </div>
        </div>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" method="POST">
            <form>
              <MDBox mb={2}>
                <MDInput
                  showPassword
                  type="password"
                  label="Parola nouă"
                  variant="standard"
                  fullWidth
                  name="password"
                  value={inputs.password}
                  onChange={handleChange}
                  error={errors.passwordError}
                  inputProps={{ style: { fontSize: 16 } }}
                />
                {errors.passwordError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                  >
                    Parola trebuie să aibă minim 8 caractere
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  showPassword
                  type="password"
                  label="Repetă parola"
                  variant="standard"
                  fullWidth
                  name="password_confirmation"
                  value={inputs.password_confirmation}
                  onChange={handleChange}
                  error={errors.confirmError}
                  inputProps={{ style: { fontSize: 16 } }}
                />
                {errors.confirmError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                  >
                    Parolele trebuie sa coincidă
                  </MDTypography>
                )}
              </MDBox>

              {errors.error && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  {errors.textError}
                </MDTypography>
              )}

              <MDBox mt={4} mb={1}>
                <Button
                  className="w-full h-10 bg-btn-primary"
                  disabled={loading === true}
                  type="submit"
                  onClick={handleSubmit}
                >
                  {loading === true
                    ? 'Se trimite...'
                    : registering
                      ? 'Creează cont'
                      : 'Schimbă parola'}
                </Button>
              </MDBox>
            </form>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  )
}

export default PasswordReset
